// extracted by mini-css-extract-plugin
export default {"wrapper":"EditableItemName_wrapper__p5fFQ","input":"EditableItemName_input__1tuOX"};